/**
 * 题目组件公共props
 */
const publicProps = {
  // 习题基础数据
  data: {
    type: Object,
    default: () => {},
  },
  // 习题数据
  exercise: {
    type: Object,
    default: () => {},
  },
  // 习题类型
  type: {
    type: Number,
  },
  // 是否为详情
  detail: {
    type: Boolean,
    default: false,
  },
  // 习题序号
  index: {
    type: [Number, String],
    default: 0,
  },
  // 习题来源 手动录入|拍照录入
  source: {
    type: String,
    default: 'manual', // photo
  },
  // 是否展示题型标签
  showType: {
    type: Boolean,
    default: true,
  },
  // 是否展示右侧操作按钮
  showOperation: {
    type: Boolean,
    default: true,
  },
  // 是否作为小题嵌套
  isNested: {
    type: Boolean,
    default: false,
  },
  // 是否作为app问答习题展示
  isApp: {
    type: Boolean,
    default: false,
  },
}
export default publicProps
